const desktopNavMenuButtons = document.querySelectorAll(
  "#primary-menu .menu-item-has-children"
);
const desktopNavHeader = document.querySelector(".site-header");

const EnterDesktopMenuItem = (navButton) => {
  //get the clicked menu item and its sub menu
  const buttonListElement = navButton.closest(".menu-item-has-children");
  const itemMegaMenu = buttonListElement.querySelector(".mega-menu-one");

  //if those menus are null - exit
  if (!buttonListElement || !itemMegaMenu) return;

  //for each menu with a sub menu
  desktopNavMenuButtons.forEach((otherNavButton) => {
    const otherButtonListElement = otherNavButton.closest(
      ".menu-item-has-children"
    );

    const otherItemMegaMenu =
      otherButtonListElement.querySelector(".mega-menu-one");
    const otherItemMegaMenuSub = otherButtonListElement.querySelector(
      ".mega-menu-one__sub-item-list"
    );

    //If we click on another item with children, close the current menu
  });

  //add open class to clicked menu item
  buttonListElement.classList.toggle("open");

  //add open attribute to the sub menu
  const isOpen = itemMegaMenu.getAttribute("data-open") === "true";

  //set the open attribute based off current value
  itemMegaMenu.setAttribute("data-open", "true");

  //if the sub menu data is open - add class to the site header
  if (itemMegaMenu.dataset.open === "true") {
    desktopNavHeader.classList.add("mega-menu-open");
  }
};

const LeaveDesktopMenuItem = (navButton) => {
  //get the clicked menu item and its sub menu
  const buttonListElement = navButton.closest(".menu-item-has-children");
  const itemMegaMenu = buttonListElement.querySelector(".mega-menu-one");

  //if those menus are null - exit
  if (!buttonListElement || !itemMegaMenu) return;

  //for each menu with a sub menu
  desktopNavMenuButtons.forEach((otherNavButton) => {
    const otherButtonListElement = otherNavButton.closest(
      ".menu-item-has-children"
    );
    const otherItemMegaMenu =
      otherButtonListElement.querySelector(".mega-menu-one");
    const otherItemMegaMenuSub = otherButtonListElement.querySelector(
      ".mega-menu-one__sub-item-list"
    );

    //If we click on another item with children, close the current menu
    if (otherButtonListElement !== buttonListElement) {
      otherButtonListElement.classList.remove("open");
      otherItemMegaMenu.setAttribute("data-open", "false");
      if (otherItemMegaMenuSub) {
        otherItemMegaMenuSub.setAttribute("data-open", "false");
      }
      desktopNavHeader.classList.remove("mega-menu-open");
    }
  });

  //add open class to clicked menu item
  buttonListElement.classList.toggle("open");

  //add open attribute to the sub menu
  const isOpen = itemMegaMenu.getAttribute("data-open") === "true";

  //set the open attribute based off currnt value
  itemMegaMenu.setAttribute("data-open", "false");

  //if the sub menu data is open - add class to the site header
  if (itemMegaMenu.dataset.open === "true") {
    desktopNavHeader.classList.add("mega-menu-open");

    //if the sub menu data is closed  - remove class to the site header
  } else {
    desktopNavHeader.classList.remove("mega-menu-open");
  }
};

//On hover sub menu
desktopNavMenuButtons.forEach((navItemButton) => {
  navItemButton.addEventListener("mouseover", (e) => {
    e.preventDefault();
    EnterDesktopMenuItem(navItemButton);
  });
});

//Off hover enter sub menu
desktopNavMenuButtons.forEach((navItemButton) => {
  navItemButton.addEventListener("mouseout", (e) => {
    e.preventDefault();
    LeaveDesktopMenuItem(navItemButton);
  });
});

const desktopNavMenuButtons_sub = document.querySelectorAll(
  "#primary-menu .sub-menu-item-has-children"
);

const EnterDesktopMenuItem_sub = (navButton_sub) => {
  navButton_sub.classList.toggle("active");

  const buttonListElement_sub = navButton_sub.closest(
    ".sub-menu-item-has-children"
  );
  const itemMegaMenu_sub = buttonListElement_sub.querySelector(
    ".mega-menu-one__sub-item-list"
  );
  const buttonLink = buttonListElement_sub.querySelector(".inner-nav-link");

  if (!buttonListElement_sub || !itemMegaMenu_sub) {
    return;
  }

  desktopNavMenuButtons_sub.forEach((otherNavButton_sub) => {
    const otherButtonListElement_sub = otherNavButton_sub.closest(
      ".sub-menu-item-has-children"
    );
    const otherItemMegaMenu_sub = otherButtonListElement_sub.querySelector(
      ".mega-menu-one__sub-item-list"
    );
    const buttonLink =
      otherButtonListElement_sub.querySelector(".inner-nav-link");

    if (otherButtonListElement_sub !== buttonListElement_sub) {
      otherButtonListElement_sub.classList.remove("open");
      otherItemMegaMenu_sub.setAttribute("data-open", "false");
      buttonLink.classList.remove("active");
    }
  });

  buttonLink.classList.toggle("active");
  buttonListElement_sub.classList.toggle("open");
  const isOpen_sub = itemMegaMenu_sub.getAttribute("data-open") === "true";
  itemMegaMenu_sub.setAttribute("data-open", "true");
};

const LeaveDesktopMenuItem_sub = (navButton_sub) => {
  navButton_sub.classList.toggle("active");
  const buttonListElement_sub = navButton_sub.closest(
    ".sub-menu-item-has-children"
  );
  const itemMegaMenu_sub = buttonListElement_sub.querySelector(
    ".mega-menu-one__sub-item-list"
  );
  const buttonLink = buttonListElement_sub.querySelector(".inner-nav-link");

  if (!buttonListElement_sub || !itemMegaMenu_sub) {
    return;
  }

  desktopNavMenuButtons_sub.forEach((otherNavButton_sub) => {
    const otherButtonListElement_sub = otherNavButton_sub.closest(
      ".sub-menu-item-has-children"
    );
    const otherItemMegaMenu_sub = otherButtonListElement_sub.querySelector(
      ".mega-menu-one__sub-item-list"
    );
    const buttonLink =
      otherButtonListElement_sub.querySelector(".inner-nav-link");

    if (otherButtonListElement_sub !== buttonListElement_sub) {
      otherButtonListElement_sub.classList.remove("open");
      otherItemMegaMenu_sub.setAttribute("data-open", "false");
      buttonLink.classList.remove("active");
    }
  });

  buttonLink.classList.toggle("active");
  buttonListElement_sub.classList.toggle("open");
  const isOpen_sub = itemMegaMenu_sub.getAttribute("data-open") === "true";
  itemMegaMenu_sub.setAttribute("data-open", "false");
};

desktopNavMenuButtons_sub.forEach((navItemButton_sub) => {
  const buttonListElement_sub = navItemButton_sub.closest(
    ".sub-menu-item-has-children"
  );
  const itemMegaMenu_sub = buttonListElement_sub.querySelector(
    ".mega-menu-one__sub-item-list"
  );
  const itemMegaMenu_sub_container = itemMegaMenu_sub.querySelector(
    ".mega-menu-one__sub-item-list-container"
  );
  const ParentWidth =
    buttonListElement_sub.closest(".mega-menu-one").offsetWidth;
  const ParentHeight =
    buttonListElement_sub.closest(".mega-menu-one").offsetHeight;
  itemMegaMenu_sub_container.style.minWidth = ParentWidth + "px";
  itemMegaMenu_sub_container.style.minHeight = ParentHeight + "px";

  navItemButton_sub.addEventListener("mouseover", (e) => {
    const subWrapper = navItemButton_sub.closest(".mega-menu-one__wrapper");

    setTimeout(() => {
      subWrapper.style.borderRight = "none";
    }, "0");

    EnterDesktopMenuItem_sub(navItemButton_sub);
  });

  navItemButton_sub.addEventListener("mouseout", (e) => {
    const subWrapper = navItemButton_sub.closest(".mega-menu-one__wrapper");

    setTimeout(() => {
      subWrapper.style.borderRight = "1px solid #ededed";
    }, "0");
    LeaveDesktopMenuItem_sub(navItemButton_sub);
  });
});
